import { Page } from "../../shared/utils/http-utils";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { AdminUser } from "../models/AdminUser";

export const AdminUserApi = {
  page: async (pageSize: number, pageNumber: number) =>
    await jwtAuthAxios().get<Page<AdminUser>>(`/admin/users`, {
      params: { "page[size]": pageSize, "page[number]": pageNumber },
    }),

  transferReferences: async (userId: string, targetEmail: string) =>
    await jwtAuthAxios().post<void>(
      `/admin/users/${userId}/transfer-references`,
      { email: targetEmail }
    ),

  resendInvitation: async (userId: string) =>
    await jwtAuthAxios().post<void>(`/admin/users/${userId}`),

  delete: async (userId: string) =>
    await jwtAuthAxios().delete(`/admin/users/${userId}`),
};
